module.exports = __webpack_public_path__ + "img/5.820bbbb5.png";